import { useCallback, useEffect } from 'react'
import { crud } from '@think-internet/zeus-frontend-package'
import props from '../../../redux/props'
import { Company } from '../../../types/Controlling/Company'
import { useDispatch, useSelector } from 'react-redux'
import { setLocal } from '../../../redux/action/local'

type Pull = () => Promise<void>

const useLoadControllingCompanies = (): [Company[] | null, Pull] => {
  const companyFeature = crud.use(props.CONTROLLING_COMPANY)
  const companies = useSelector((s) => s[props.CONTROLLING_COMPANY])
  const dispatch = useDispatch()

  const pull = useCallback(async () => {
    const companies = await companyFeature.list({})
    if (companies) {
      dispatch(setLocal(props.CONTROLLING_COMPANY, companies))
    }
  }, [companyFeature, dispatch])

  useEffect(() => {
    if (!companies) pull()
  }, [companies, pull])

  return [companies, pull]
}

export default useLoadControllingCompanies
